import {
  PersonOutline,
  GridView,
  Settings,
  AddBusiness,
  AccountCircle,
  DashboardCustomize,
  AccessTime,
} from "@mui/icons-material";

// PAGES
import DashboardPage from "views/Dashboard/Dashboard.js";
import UsersListAdmin from "views/Admin/UsersListAdmin.js";
import CompaniesListAdmin from "views/Admin/CompaniesListAdmin.js";
import TransactionsSuperAdmin from "views/Admin/TransactionsSuperAdmin.js";
import ProfilesListAdmin from "views/Admin/ProfilesListAdmin.js";
import ProfilePrivileges from "views/Admin/ProfilePrivilegesListAdmin.js";
import CountriesListAdmin from "views/Admin/CountriesListAdmin.js";
import StatesListAdmin from "views/Admin/StatesListAdmin.js";
import CitiesListAdmin from "views/Admin/CitiesListAdmin.js";
import GenderListAdmin from "views/Admin/GenderListAdmin.js";
import MyAccount from "views/Admin/MyAccount.js";
import ProductsListAdmin from "views/Admin/ProductsListAdmin.js";
import WebHookPayAdmin from "views/Admin/WebHookPayAdmin.js";
import AdvisorsListAdmin from "views/Admin/AdvisorsListAdmin.js";
import ExternalSupplierListAdmin from "views/Admin/ExternalSupplierListAdmin.js";

const dashboardRoutes = [
  {
    id: 0,
    subId: "",
    path: "/dashboard",
    name: "Inicio",
    rtlName: "لوحة القيادة",
    icon: GridView,
    component: DashboardPage,
    layout: "/superadmin",
    submenu: [],
    margin: 0,
  },
  // MENU USERS
  {
    id: 0,
    subId: "",
    path: "/users",
    name: "Usuarios",
    rtlName: "لوحة القيادة",
    icon: PersonOutline,
    component: UsersListAdmin,
    layout: "/superadmin",
    submenu: [],
    margin: 0,
  },
  // MENU PRODUCTS
  {
    id: 0,
    subId: "",
    path: "/products",
    name: "Productos",
    rtlName: "لوحة القيادة",
    icon: DashboardCustomize,
    component: ProductsListAdmin,
    layout: "/superadmin",
    submenu: [],
    margin: 0,
  },
  /* START ADMIN COMPANIES */
  {
    id: 2,
    subId: "",
    path: "",
    name: "Empresas",
    rtlName: "",
    icon: AddBusiness,
    component: "",
    layout: "/superadmin",
    submenu: [
      {
        subId: 2,
        name: "Listado",
        path: "/companies",
      },
      {
        subId: 2,
        name: "Transacciones",
        path: "/transactions-admin",
      },
      {
        subId: 2,
        name: "Transacciones Ayasa",
        path: "/transactions-ayasa",
      },
    ],
    margin: 0,
  },
  {
    // SUBMENU COMPANIES list
    id: "",
    subId: 2,
    path: "/companies",
    name: "",
    rtlName: "",
    icon: "",
    component: CompaniesListAdmin,
    layout: "/superadmin",
    submenu: [],
  },
  {
    // SUBMENU TRANSACTIONS list
    id: "",
    subId: 2,
    path: "/transactions-admin",
    name: "",
    rtlName: "",
    icon: "",
    component: TransactionsSuperAdmin,
    layout: "/superadmin",
    submenu: [],
  },
  {
    // SUBMENU EXTERNAL SUPPLIER list
    id: "",
    subId: 2,
    path: "/transactions-ayasa",
    name: "",
    rtlName: "",
    icon: "",
    component: ExternalSupplierListAdmin,
    layout: "/superadmin",
    submenu: [],
  },
  /* START ADMIN*/
  {
    id: 1,
    subId: "",
    path: "",
    name: "Administración",
    rtlName: "",
    icon: Settings,
    component: "",
    layout: "/superadmin",
    submenu: [
      {
        subId: 1,
        name: "Perfiles",
        path: "/profilelist",
      },
      {
        subId: 1,
        name: "Permisos por perfiles",
        path: "/profileprivileges",
      },
      /* {
        subId: 1,
        name: "Módulos",
        path: "/modules",
      },*/
      {
        subId: 1,
        name: "Paises",
        path: "/countries",
      },
      {
        subId: 1,
        name: "Provincias",
        path: "/states",
      },
      {
        subId: 1,
        name: "Ciudades",
        path: "/cities",
      },
      {
        subId: 1,
        name: "Género",
        path: "/gender",
      },
      {
        subId: 1,
        name: "Asesores (AYASA)",
        path: "/advisor",
      },
    ],
    margin: 0,
  },
  {
    // SUBMENU Profiles list
    id: "",
    subId: 1,
    path: "/profilelist",
    name: "",
    rtlName: "",
    icon: "",
    component: ProfilesListAdmin,
    layout: "/superadmin",
    submenu: [],
  },
  /*{
    // SUBMENU MENU list
    id: "",
    subId: 1,
    path: "/modules",
    name: "",
    rtlName: "",
    icon: "",
    component: MenuListAdmin,
    layout: "/superadmin",
    submenu: [],
  },*/
  {
    // SUBMENU PROFILE/PRIVILEGES list
    id: "",
    subId: 1,
    path: "/profileprivileges",
    name: "",
    rtlName: "",
    icon: "",
    component: ProfilePrivileges,
    layout: "/superadmin",
    submenu: [],
  },
  {
    // SUBMENU COUNTRIES list
    id: "",
    subId: 1,
    path: "/countries",
    name: "",
    rtlName: "",
    icon: "",
    component: CountriesListAdmin,
    layout: "/superadmin",
    submenu: [],
  },
  {
    // SUBMENU STATES list
    id: "",
    subId: 1,
    path: "/states",
    name: "",
    rtlName: "",
    icon: "",
    component: StatesListAdmin,
    layout: "/superadmin",
    submenu: [],
  },
  {
    // SUBMENU CITIES list
    id: "",
    subId: 1,
    path: "/cities",
    name: "",
    rtlName: "",
    icon: "",
    component: CitiesListAdmin,
    layout: "/superadmin",
    submenu: [],
  },
  {
    // SUBMENU GENDER list
    id: "",
    subId: 1,
    path: "/gender",
    name: "",
    rtlName: "",
    icon: "",
    component: GenderListAdmin,
    layout: "/superadmin",
    submenu: [],
  },
  {
    // SUBMENU ADVISOR list
    id: "",
    subId: 1,
    path: "/advisor",
    name: "",
    rtlName: "",
    icon: "",
    component: AdvisorsListAdmin,
    layout: "/superadmin",
    submenu: [],
  },
  {
    id: 0,
    subId: "",
    path: "/myaccount",
    name: "Tu perfil",
    rtlName: "لوحة القيادة",
    icon: AccountCircle,
    component: MyAccount,
    layout: "/superadmin",
    submenu: [],
    margin: 1,
  },
  {
    id: 10,
    subId: "",
    path: "/webhook",
    name: "Automatización de pagos",
    rtlName: "",
    icon: AccessTime,
    component: WebHookPayAdmin,
    layout: "/superadmin",
    submenu: [],
    margin: 1,
  },
];

export default dashboardRoutes;
